module.exports = __webpack_public_path__ + "static/img/14000673.f946b907.png";